// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../actions'
import Organization from '../components/Organization'
import Loading from '../components/Loading'
import { getOrganization } from '../selectors'
import type { OrganizationType } from '../types/OrganizationType'
import styles from './organizationPage.less'

class OrganizationPage extends Component {
  props: {
    params: {
      id: string,
    },
    isFetching: boolean,
    item: OrganizationType,
    fetchOrgIfNeeded: Function,
  }

  componentWillMount() {
    this.props.fetchOrgIfNeeded(this.props.params.id)
  }

  render() {
    if (this.props.isFetching) {
      return <Loading />
    }
    return (
      <div className={styles.page}>
        <Organization {...this.props.item} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  ...getOrganization(state),
})

export default connect(mapStateToProps, actions)(OrganizationPage)



// WEBPACK FOOTER //
// ./src/pages/OrganizationPage.js